<template>
  <div id="app" ref="appTop">
    <FormStep ref="formStep" />
  </div>
  <!-- v 2.0 -->
</template>

<script>
import { onMounted, ref, nextTick } from "vue";
import { useStore } from "vuex";
import { mapGetters } from "vuex";

import FormStep from "@/components/form/FormStep.vue";


export default {
  name: "App",
  components: {
    FormStep
  },
  computed: {
    ...mapGetters("config", ["getCurrentFormConfig"]),
  },
  setup() {
    const store = useStore();
    const formStep = ref(null);
    const sectionRefs = ref({});

    onMounted(async () => {
      // Guard: only re-initialize platforms if not already loaded (avoids wiping pre-selections)
      if (store.state.platforms.platforms.length === 0) {
        store.dispatch("platforms/initializePlatforms");
      }
      sectionRefs.value = formStep.value.sectionRefs;

      // Auto-advance for multi-step forms when URL pre-fill is active
      if (store.state.config.hasUrlPrefill && store.state.config.formType === 'tpsp-commercial') {
        const totalSteps = store.getters["config/getCurrentFormSteps"].length;
        const tryAdvance = async () => {
          await nextTick();
          const currentStep = store.state.validation.currentStep;
          if (currentStep >= totalSteps) return;
          if (store.getters["validation/isStepValid"](currentStep)) {
            store.dispatch("validation/updateCurrentStep", currentStep + 1);
            await nextTick();
            await tryAdvance();
          }
        };
        await tryAdvance();
      }
    });

    return {
      formStep,
      sectionRefs,
    };
  },
};
</script>

<style>
.form_wrap {
  border: 1px solid transparent;
}

.isInvalid {
  border: 1px solid #990000 !important;
}

.validationMessage {
  color: #990000;
  font-size: 0.8rem;
}

.isInvalid {
  border: 1px solid #990000 !important;
}
</style>
